import { useEffect } from "react";
import { useLocation } from "react-router";
import { getSecureItem } from "../utils/secureStorage";

const PUBLIC_ROUTES = [
    "/login",
    "/forgot-password",
    "/setpassword",
];

export default function useIdleLogout(
    logoutFn,
    idleTime = 2 * 60 * 60 * 1000
) {
    const location = useLocation();

    useEffect(() => {
        // ⛔ Skip idle logic on public pages
        if (PUBLIC_ROUTES.includes(location.pathname)) return;

        let timer;
        let lastActivity = Date.now();

        const forceLogout = () => {
            logoutFn();
        };

        const resetTimer = () => {
            lastActivity = Date.now();
            clearTimeout(timer);
            timer = setTimeout(forceLogout, idleTime);
        };

        const events = [
            "mousemove",
            "keydown",
            "scroll",
            "click",
            "touchstart",
        ];

        // 🛡 PRO TIP: Token tampering / deletion check
        const securityCheck = () => {
            const token = getSecureItem("authToken");
            if (!token) {
                forceLogout();
            }
        };

        events.forEach((event) =>
            window.addEventListener(event, resetTimer)
        );

        // 🔁 Periodic security validation (every 30s)
        const securityInterval = setInterval(securityCheck, 30 * 1000);

        resetTimer(); // start timer

        return () => {
            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
            clearTimeout(timer);
            clearInterval(securityInterval);
        };
    }, [logoutFn, idleTime, location.pathname]);
}
